<template>
  <v-container fluid>
    <v-data-table-server
      :headers="headers"
      :items="buyingGroups"
      :search="search"
      density="compact"
      :items-length="totalItems"
      :loading="loadingDatatables"
      @update:sortBy="toSort"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            density="compact"
            :label="this.$t('search')"
            class="pl-2"
            :prepend-inner-icon="mdiMagnify"
            @update:modelValue="toSearchBack"
            variant="solo-filled"
            flat
            hide-details
            single-line
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            variant="elevated"
            class="mb-2 text-white mr-3"
            :prepend-icon="mdiAccountPlus"
            color="#ffb300"
            @click="openDialog"
            dark
          >
            {{ $t("admin.new-buying-group") }}
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">
          {{ mdiPencil }}
        </v-icon>
        <v-icon size="small" @click="deleteItem(item)">
          {{ mdiDelete }}
        </v-icon>
      </template>

      <template v-slot:bottom>
        <pagination-dynamic :store="'buyingGroups'"></pagination-dynamic>
      </template>
    </v-data-table-server>
    <add-edit-buying-group
      :modelDialog="buyingGroupDialog"
      @close="buyingGroupDialog = false"
    ></add-edit-buying-group>
  </v-container>
</template>

<script>
import { mdiPencil, mdiDelete, mdiMagnify, mdiAccountPlus } from "@mdi/js";
import PaginationDynamic from "@/components/PaginationDynamic.vue";
import AddEditBuyingGroup from "./admin/AddEditBuyingGroup.vue";
import paginate from "@/mixins/paginations";
import { mapState } from "vuex";

export default {
  name: "BuyingGroupAdmin",
  components: { AddEditBuyingGroup, PaginationDynamic },
  mixins: [paginate],
  data() {
    return {
      mdiAccountPlus,
      mdiMagnify,
      mdiPencil,
      mdiDelete,
      dialog: false,
      dialogDelete: false,
      buyingGroupDialog: false,
      itemsPerPage: 15,
      page: 1,
      headers: [
        { title: "Nom", key: "name" },
        { title: "Actions", key: "actions", sortable: false, align: "end" }
      ]
    };
  },
  computed: {
    ...mapState({
      buyingGroups: (state) => state.buyingGroups.items,
      loadingDatatables: (state) => state.loadingTables,
      totalItems: (state) => state.paginations.totalCount,
      editedId: (state) => state.buyingGroups.editedId
    }),
    pageCount() {
      return Math.ceil(this.buyingGroups.length / this.itemsPerPage);
    },
    search: {
      get() {
        return this.$store.state.paginations.search;
      },
      set(value) {
        this.$store.commit("paginations/setSearch", value);
      }
    }
  },
  methods: {
    toSort(item) {
      this.sortBy(item, "buyingGroups");
    },
    toSearchBack(value, time = 500) {
      this.searchBack(value, time, "buyingGroups");
    },
    openDialog() {
      this.$store.commit("buyingGroups/setEditedId", -1);
      this.$store.commit(
        "buyingGroups/setEditedItem",
        Object.assign({}, this.$store.state.buyingGroups.defaultItem)
      );
      this.buyingGroupDialog = true;
    },
    editItem(item) {
      this.$store.commit("buyingGroups/setEditedId", item.id);
      this.$store.commit("buyingGroups/setEditedItem", Object.assign({}, item));
      this.buyingGroupDialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("alert.delete.buying-group"))) {
        this.$store
          .dispatch("buyingGroups/deleteItem", item.id)
          .then(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.success.buying-group-delete"),
              color: "success"
            });
            this.toSearchBack(this.search, 500, "buyingGroups");
          })
          .catch(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.buying-group-delete"),
              color: "error"
            });
          });
      }
    }
  }
};
</script>
